import PropTypes from 'prop-types';
import { createContext, useMemo } from 'react';

// project imports
import config from 'config';
import { useLocalStorage } from 'hooks/useLocalStorage';

// ==============================|| CONFIG CONTEXT ||============================== //

export const ConfigContext = createContext(undefined);

// ==============================|| CONFIG PROVIDER ||============================== //

export function ConfigProvider({ children }) {
  const { state, setState, setField, resetState } = useLocalStorage('berry-config-vite-js', config);

  const activeState = useMemo(() => {
    return { ...config, ...state, mode: 'light', fontFamily: `'Poppins', sans-serif`, borderRadius: 8 };
  }, [state]);

  const memoizedValue = useMemo(() => ({ state: activeState, setState, setField, resetState }), [activeState, setField, setState, resetState]);

  return <ConfigContext.Provider value={memoizedValue}>{children}</ConfigContext.Provider>;
}

ConfigProvider.propTypes = { children: PropTypes.node };
